/**
 * Pending Approval Page
 * Shows after public signup while account is awaiting admin review.
 */
import React from "react";
import { Link } from "react-router-dom";
import { Clock, CheckCircle2, Mail } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_circularity-hub/artifacts/hwzjkab2_DecarbonIQ%20%2814%29.png";

export default function PendingApproval() {
  return (
    <div className="min-h-screen bg-[#0F172A] flex flex-col items-center justify-center px-6 py-12"
      data-testid="pending-approval-page">
      <div className="max-w-md w-full text-center">
        <div className="bg-[#0B1220] rounded-xl px-4 py-2 inline-block mb-8">
          <img src={LOGO_URL} alt="DeCarbonIQ" className="h-7" style={{ filter: "brightness(0) invert(1)" }} />
        </div>

        <div className="w-16 h-16 bg-teal-600/20 border border-teal-400/30 rounded-xl flex items-center justify-center mx-auto mb-5">
          <Clock size={28} className="text-teal-400" />
        </div>

        <h1 className="text-2xl font-bold text-white mb-2 tracking-tight">Application Received</h1>
        <p className="text-slate-400 text-sm mb-6 leading-relaxed">
          Your account is pending review. Our team will assess your application and notify you within <strong className="text-white">24–48 hours</strong>.
        </p>

        <div className="bg-white/5 border border-white/10 rounded-xl p-5 mb-6 text-left space-y-3">
          {[
            ["Application submitted", "Your details have been recorded.", true],
            ["Admin review in progress", "We're reviewing your request.", false],
            ["Email confirmation sent", "Check your inbox for a confirmation.", true],
            ["Access granted", "You'll receive an email once approved.", false],
          ].map(([step, desc, done]) => (
            <div key={step} className="flex items-start gap-3">
              <div className={`w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 ${done ? "bg-teal-600" : "bg-white/10"}`}>
                {done ? <CheckCircle2 size={11} className="text-white" /> : <div className="w-2 h-2 rounded-full bg-slate-600" />}
              </div>
              <div>
                <p className={`text-xs font-semibold ${done ? "text-white" : "text-slate-500"}`}>{step}</p>
                <p className="text-[10px] text-slate-500">{desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="flex items-center justify-center gap-2 text-xs text-slate-500 mb-6">
          <Mail size={13} />
          <span>Check your email for a confirmation and updates on your application.</span>
        </div>

        <Link to="/login"
          className="text-sm text-teal-400 hover:text-teal-300 transition-colors">
          Already approved? Sign in →
        </Link>
      </div>
    </div>
  );
}
